import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CycleProvider } from './context/CycleContext';
import ProtectedRoute from './components/ProtectedRoute';
import RoleBasedRoute from './components/RoleBasedRoute';
import BookmarkRedirect from './components/BookmarkRedirect';
import PrintProtection from './components/PrintProtection';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard';
import Journal from './pages/Journal';
import SelfAssessment from './pages/journal/SelfAssessment';
import CurrentHealth from './pages/journal/CurrentHealth';
import Reflection from './pages/journal/Reflection';
import Transformation from './pages/journal/Transformation';
import Progress from './pages/journal/Progress';
import CheckIn01 from './pages/journal/CheckIn01';
import CheckIn02 from './pages/journal/CheckIn02';
import CheckIn03 from './pages/journal/CheckIn03';
import CheckIn04 from './pages/journal/CheckIn04';
import CheckIn05 from './pages/journal/CheckIn05';
import CheckIn06 from './pages/journal/CheckIn06';
import Settings from './pages/Settings';
import PaymentCallback from './pages/PaymentCallback';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

function App() {
    return (
        <AuthProvider>
            <CycleProvider>
                    <PrintProtection />
                    <ToastContainer
                        position="top-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                    />
                    <Router>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        {/* Admin Routes - Only accessible by admin and doctor roles */}
                        <Route
                            path="/admin"
                            element={
                                <RoleBasedRoute allowedRoles={['admin', 'doctor']}>
                                    <AdminDashboard />
                                </RoleBasedRoute>
                            }
                        />

                        {/* Patient Routes - Only accessible by patient role */}
                        <Route
                            element={
                                <RoleBasedRoute allowedRoles={['patient']}>
                                    <Layout />
                                </RoleBasedRoute>
                            }
                        >
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="/journal" element={<Journal />}>
                                <Route path="self-assessment" element={<SelfAssessment />} />
                                <Route path="current-health" element={<CurrentHealth />} />
                                <Route path="reflection" element={<Reflection />} />
                                <Route path="transformation" element={<Transformation />} />
                            <Route path="progress" element={<Progress />} />
                            <Route path="checkin-01" element={<CheckIn01 />} />
                            <Route path="checkin-02" element={<CheckIn02 />} />
                            <Route path="checkin-03" element={<CheckIn03 />} />
                            <Route path="checkin-04" element={<CheckIn04 />} />
                            <Route path="checkin-05" element={<CheckIn05 />} />
                            <Route path="checkin-06" element={<CheckIn06 />} />
                        </Route>
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/payment/callback" element={<PaymentCallback />} />
                        </Route>

                    <Route path="/" element={<ProtectedRoute><BookmarkRedirect /></ProtectedRoute>} />
                    <Route path="*" element={<ProtectedRoute><BookmarkRedirect /></ProtectedRoute>} />
                </Routes>
            </Router>
                </CycleProvider>
        </AuthProvider>
    );
}

export default App;
